export default __webpack_public_path__ + "static/Scribble-9f0dcbad87afef1a9e0457a577bbb9fc.svg";